var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500 z-10",
                      attrs: {
                        to: {
                          name: _vm.routes.MANAGE_TEAMS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-bold text-lg" }, [
                        _vm._v("Groups"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "GroupModalWithButton",
          fn: function () {
            return [
              _c("GroupModalWithButton", {
                staticClass: "items-",
                attrs: {
                  buttonText: "Create New Group",
                  companyId: _vm.companyId,
                  currentUser: _vm.currentUser,
                },
                on: { refetch: _vm.refetchGroups },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "groupMessage",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col w-full overflow-y-scroll scrollbar h-36",
                },
                _vm._l(_vm.groups, function (group) {
                  return _c(
                    "div",
                    {
                      key: group.id,
                      staticClass:
                        "grid grid-cols-2 py-2 border-1 border-t-0 border-l-0 border-r-0",
                    },
                    [
                      _c(
                        "RouterLink",
                        {
                          attrs: {
                            to: {
                              name: _vm.routes.GROUP_DETAILS,
                              params: { id: group.id },
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("CircleWithInitials", {
                                staticClass: "mr-2",
                                attrs: { title: group.name },
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mt-1.5 flex flex-inline text-xs",
                                },
                                [_vm._v(_vm._s(group.name))]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("GroupConversationProvider", {
                        staticClass: "grid place-items-end mr-6 mt-6",
                        attrs: {
                          contractors: group.contractors,
                          managers: group.managers,
                          currentUserRole: _vm.currentUser.role,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({
                                groupConversationUsers,
                                participantsExist,
                              }) {
                                return [
                                  participantsExist
                                    ? _c(
                                        "ColorIconContainer",
                                        {
                                          staticClass: "-mt-4",
                                          attrs: { iconStyle: "" },
                                          on: { click: _vm.groupMessage },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mb-4 transform hover:text-purple-500 hover:scale-110 ml-11/12",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.groupMessage(group)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "16",
                                                    height: "15",
                                                    viewBox: "0 0 13 12",
                                                    fill: "none",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M10.9612 0H1.21791C0.54806 0 0.00608955 0.54 0.00608955 1.2L0 12L2.43582 9.6H10.9612C11.631 9.6 12.1791 9.06 12.1791 8.4V1.2C12.1791 0.54 11.631 0 10.9612 0ZM9.13433 7.2H3.04478C2.70985 7.2 2.43582 6.93 2.43582 6.6C2.43582 6.27 2.70985 6 3.04478 6H9.13433C9.46925 6 9.74328 6.27 9.74328 6.6C9.74328 6.93 9.46925 7.2 9.13433 7.2ZM9.13433 5.4H3.04478C2.70985 5.4 2.43582 5.13 2.43582 4.8C2.43582 4.47 2.70985 4.2 3.04478 4.2H9.13433C9.46925 4.2 9.74328 4.47 9.74328 4.8C9.74328 5.13 9.46925 5.4 9.13433 5.4ZM9.13433 3.6H3.04478C2.70985 3.6 2.43582 3.33 2.43582 3C2.43582 2.67 2.70985 2.4 3.04478 2.4H9.13433C9.46925 2.4 9.74328 2.67 9.74328 3C9.74328 3.33 9.46925 3.6 9.13433 3.6Z",
                                                      fill: "#1A7BEE",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("CreateGroupConversationModal", {
                                    attrs: {
                                      companyId: _vm.companyId,
                                      currentUserId: _vm.currentUser.id,
                                      groupConversationUsers:
                                        groupConversationUsers,
                                      projectTitle: _vm.clickedGroup.name,
                                    },
                                    model: {
                                      value: _vm.newConversationDialog,
                                      callback: function ($$v) {
                                        _vm.newConversationDialog = $$v
                                      },
                                      expression: "newConversationDialog",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "items-center justify- text-innerCard-primary",
          attrs: {
            itemNumber: _vm.newGroupsLength,
            itemTitle: "Groups",
            flexRow: "",
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("GroupsIcon", {
                    staticClass: "h-5 w-5 fill-current text-primary-500",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.newGroupsLength
            ? _c(
                "div",
                { staticClass: "flex flex-wrap items-center" },
                _vm._l(_vm.newGroups, function (group, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1 mt-1",
                    attrs: {
                      showTooltip: "",
                      title: group.name,
                      id: group.id,
                      route: _vm.routes.GROUP_DETAILS,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }